export default __webpack_public_path__ + "static/media/Bifurcated-drier-with-tails-Edited-1.3a86287f.jpg";